import actionTypes from '../actionTypes';
export default {
  setCallList: data => dispatch => {
    dispatch({
      type: actionTypes.ONLINE_CALL_LIST,
      payload: data
    });
  },
  setTeam: data => dispatch => {
    dispatch({
      type: actionTypes.ONLINE_TEAM,
      payload: data
    });
  },
  setBreak: data => dispatch => {
    dispatch({
      type: actionTypes.SET_BREAK_LIST,
      payload: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/action/online.action.js